module.exports = __webpack_public_path__ + "img/signr-becomes-verified.05bf2827.png";